export default [
  { key: 0, label: "English", value: "en-US", currency: "dollar", money: "$" },
  { key: 1, label: "Español", value: "es-ES", currency: "euro", money: "€" },
  { key: 3, label: "Deutsch", value: "de-DE", currency: "euro", money: "€" },
  { key: 4, label: "Italiano", value: "it-IT", currency: "euro", money: "€" },
  { key: 5, label: "Português", value: "pt-PT", currency: "euro", money: "€" },
  { key: 6, label: "Русский", value: "ru-RU", currency: "рубль", money: "₽" },
  { key: 7, label: "Српски", value: "sr-RS", currency: "динар", money: "дин." }
];
